<template>
  <a-sub-menu :key="menuInfo.key" v-bind="$props" v-on="$listeners">
    <span slot="title">
       <a-icon :type="(JSON.parse(menuInfo.param || `{}`) || {}).icon" v-if="(JSON.parse(menuInfo.param || `{}`) || {}).icon" />
      <span>{{menuInfo.name }}</span>
    </span>
    <template v-for="item in menuInfo.children">
      <sub-menu
          v-if="item.children && item.children.length"
          :key="item.funcId"
          :menu-info="item"
      />
      <a-menu-item v-else :key="item.funcId" :path="item.url">
        <a-icon :type="(JSON.parse(item.param || `{}`) || {}).icon" v-if="(JSON.parse(item.param || `{}`) || {}).icon" />
        <span>{{ item.name }}</span>
      </a-menu-item>
    </template>
  </a-sub-menu>
</template>

<script>
import {Menu} from 'ant-design-vue'

export default {
  name: 'SubMenu',
  isSubMenu: true,
  props: {
    ...Menu.SubMenu.props,
    menuInfo: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>

<style scoped></style>
